// components/settings/FAQItem.js
import React from "react";

const FaqItem = ({ id, question, answer, isOpen, onToggle }) => {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${
            isOpen ? "" : "collapsed"
          } text-body-b1`}
          type="button"
          aria-expanded={isOpen ? "true" : "false"}
          aria-controls={id}
          onClick={() => onToggle(id)}
        >
          {question}&nbsp;
        </button>
      </h2>
      <div
        id={id}
        className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
        data-bs-parent="#setting-faqs-accordion"
      >
        <div className="accordion-body text-body-b3">{answer}</div>
      </div>
    </div>
  );
};

export default FaqItem;
